import {AutoFormWithTargetController} from "./auto_form_with_target_controller"

export default class extends AutoFormWithTargetController {
}
